import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import ParkingManagement from './pages/ParkingManagement/ParkingManagement';
import VehicleRegistration from './pages/VehicleRegistration/VehicleRegistration';
import BlacklistManagement from './pages/BlacklistManagement/BlacklistManagement';
import PaymentManagement from './pages/PaymentManagement/PaymentManagement';
import BillingManagement from './pages/BillingManagement/BillingManagement';
import Reports from './pages/Reports/Reports';
import AIMonitoring from './pages/AIMonitoring/AIMonitoring';
import PlateRecognition from './pages/PlateRecognition/PlateRecognition';
import CircularTrack from './pages/CircularTrack/CircularTrack';
import SystemAdmin from './pages/SystemAdmin/SystemAdmin';
import VIPManagement from './pages/VIPManagement/VIPManagement';
import EnvironmentControl from './pages/EnvironmentControl/EnvironmentControl';
import LaneManagement from './pages/LaneManagement/LaneManagement';
import EntryExitRecords from './pages/EntryExitRecords/EntryExitRecords';
import LocationSettings from './pages/LocationSettings/LocationSettings';
import FeeCategories from './pages/FeeCategories/FeeCategories';
import FeeSettings from './pages/FeeSettings/FeeSettings';
import VehicleTypes from './pages/VehicleTypes/VehicleTypes';
import OnsiteVehicles from './pages/OnsiteVehicles/OnsiteVehicles';
import TemporaryPaymentQuery from './pages/TemporaryPaymentQuery/TemporaryPaymentQuery';
import MonthlyPaymentQuery from './pages/MonthlyPaymentQuery/MonthlyPaymentQuery';
import ETagManagement from './pages/ETagManagement/ETagManagement';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* 公開路由 */}
            <Route path="/login" element={<Login />} />
            
            {/* 受保護的路由 */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="parking/*" element={<ParkingManagement />} />
              <Route path="vehicle-registration/*" element={<VehicleRegistration />} />
              <Route path="etag-management/*" element={<ETagManagement />} />
              <Route path="blacklist-management/*" element={<BlacklistManagement />} />
              <Route path="payments/*" element={<PaymentManagement />} />
              <Route path="billing/*" element={<BillingManagement />} />
              <Route path="temporary-payment-query/*" element={<TemporaryPaymentQuery />} />
              <Route path="monthly-payment-query/*" element={<MonthlyPaymentQuery />} />
              <Route path="reports/*" element={<Reports />} />
              <Route path="ai-monitoring/*" element={<AIMonitoring />} />
              <Route path="plate-recognition/*" element={<PlateRecognition />} />
              <Route path="circular-track/*" element={<CircularTrack />} />
              <Route path="lane-management/*" element={<LaneManagement />} />
              <Route path="entry-exit-records/*" element={<EntryExitRecords />} />
              <Route path="onsite-vehicles/*" element={<OnsiteVehicles />} />
              <Route path="system-admin/*" element={<SystemAdmin />} />
              <Route path="vip-management/*" element={<VIPManagement />} />
              <Route path="environment-control/*" element={<EnvironmentControl />} />
              <Route path="locations/*" element={<LocationSettings />} />
              <Route path="fee-categories/*" element={<FeeCategories />} />
              <Route path="fee-settings/*" element={<FeeSettings />} />
              <Route path="vehicle-types/*" element={<VehicleTypes />} />
            </Route>

            {/* 404 頁面 */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
